var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.createMove)?_c('v-btn',{staticClass:"mr-2",attrs:{"icon":"","color":"green","disabled":_vm.movable},on:{"click":_vm.check}},[_c('v-icon',[_vm._v(" fa fa-check ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }